import { ButtonBase } from '@mui/material';
import type { ReactNode } from 'react';

interface TableLinkButtonProps {
  onClick: () => void;
  children: ReactNode;
  'data-testid'?: string;
}

// Inline text link in `primary.main` that inherits the surrounding typography.
export const TableLinkButton = ({
  onClick,
  children,
  'data-testid': testId,
}: TableLinkButtonProps) => (
  <ButtonBase
    onClick={onClick}
    data-testid={testId}
    sx={{
      display: 'block',
      color: 'primary.main',
      font: 'inherit',
      fontWeight: 'inherit',
      textAlign: 'inherit',
      maxWidth: '100%',
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      '&:hover': { textDecoration: 'underline' },
    }}
  >
    {children}
  </ButtonBase>
);
